import { observable } from "mobx";
import { Type } from "class-transformer";
import VehicleResponse from "./vehicleResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class CustomerRefundCandidateChargeResponse {
  @observable
  @Type(() => VehicleResponse)
  vehicle!: VehicleResponse;

  @observable
  price!: number;

  @observable
  wasVehicleChangedDuringValidity!: boolean;
}
